import { setupI18nDirective } from './i18n'

export function setupDirectives (app) {
  setupI18nDirective(app)
}
